import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { ProgressionStepsDialog } from '@/features/jobs/details/components/JobProgressionCard/ProgressionStepsDialog'

export interface ProgressionStepsDialogContainerProps {
  vm: JobDetailsViewModel
}

export const ProgressionStepsDialogContainer = observer(
  function ProgressionStepsDialogContainer({
    vm,
  }: ProgressionStepsDialogContainerProps) {
    const progression = vm.jobProgressionVm

    return (
      <ProgressionStepsDialog
        showing={progression.stepsDialogVm.showing}
        steps={progression.stepsDialogSteps(vm.seesClientProgression)}
        description={progression.stepsDialogDescription}
        hasHistory={progression.hasProgressionHistory}
        onClose={progression.stepsDialogVm.close}
        onViewHistory={progression.viewHistoryFromSteps}
      />
    )
  },
)
